import { groupBy } from "lodash";
import type { Participant } from "@/react/types/Live/Participant";
import { usePublicLiveStreamRoom } from "../../../hooks";

interface UseGroupParticipantsProps {
  activeParticipants: Participant[];
}

export const useGroupParticipants = ({
  activeParticipants = [],
}: UseGroupParticipantsProps) => {
  const { room } = usePublicLiveStreamRoom();

  const host = activeParticipants.find(
    participant =>
      participant.role === "host" && participant.id === room?.created_by_id,
  );
  const cohosts = activeParticipants.filter(
    participant =>
      participant.role === "host" && participant.id !== room?.created_by_id,
  );
  const participantsGrouped = groupBy(activeParticipants, "role");

  const participantsGroup = {
    moderators: host
      ? [host, ...(participantsGrouped.moderator || [])]
      : participantsGrouped.moderator || [],
    cohosts,
    participants: participantsGrouped.hlsspectator || [],
  };

  return {
    host,
    participantsGroup: participantsGroup || {},
  };
};
